import React from "react";
import { TiCardAnalyticsData } from "../../../../@types";
import TiCardDetectedSamples from "./TiCardDetectedSamples";
import TiCardWeeklyRank from "./TiCardWeeklyRank";
import PostfixNumber from "../PostfixNumber";

interface Props {
  analyticsData: TiCardAnalyticsData;
}

const TiCardAnalyticsInfo = ({ analyticsData }: Props) => (
  <div className={"ticard-content__information-cards"}>
    <div className="ticard-analytics-group">
      <div className={"ticard-content__card-title"}>
        <span>Week Rank</span>
      </div>
      <div
        className={"ticard-content__card-value"}
        data-testid="ticard_analytics_info_week_rank"
      >
        <TiCardWeeklyRank weeklyRankingData={analyticsData.weekly_rating} />
      </div>
    </div>
    <div className="ticard-analytics-group">
      <div className={"ticard-content__card-title"}>
        <span>
          Total number of <br /> detected samples
        </span>
      </div>
      <div
        className={"ticard-content__card-value"}
        data-testid="ticard_analytics_info_detected_samples_total"
      >
        <PostfixNumber number={analyticsData.detected_samples.total} />
      </div>
    </div>
    <div className="ticard-analytics-group">
      <div className={"ticard-content__card-title"}>
        <span>
          Detected Samples <br /> Current Week
        </span>
      </div>
      <div
        className={"ticard-content__card-value"}
        data-testid="ticard_analytics_info_detected_samples_current_week"
      >
        <TiCardDetectedSamples
          detectedSamplesData={analyticsData.detected_samples}
        />
      </div>
    </div>
    <div className="ticard-analytics-group">
      <div className={"ticard-content__card-title"}>
        <span>
          Detected Samples <br /> Last Week
        </span>
      </div>
      <div
        className={"ticard-content__card-value"}
        data-testid="ticard_analytics_info_detected_samples_last_week"
      >
        <PostfixNumber number={analyticsData.detected_samples.last_week} />
      </div>
    </div>
  </div>
);

export default TiCardAnalyticsInfo;
